import { ReactNode } from 'react';

import { cn } from '@lib/utils';

interface TitleBoxProps {
  children: ReactNode;
  className?: string;
}

export default function TitleBox({ children, className }: TitleBoxProps) {
  const baseClassName =
    'z-[1] w-[400px] break-keep flex flex-col justify-start gap-y-4 mt-[80px] pl-5 whitespace-pre-line md:w-[1420px] md:justify-center md:gap-y-8 md:mt-[80px] 2xl:mt-[100px] md:pl-8 md:mx-auto';

  return <div className={cn(baseClassName, className)}>{children}</div>;
}
